import { PopoverPlacement } from "@idui/react-popover";
import type { FC } from "react";

import type { IRenderColumnTemplate } from "../_core";
import { FramerTooltip } from "../../../common";
import { useCourseStationsCell } from "./parts";

export const CourseStationsCellTemplate: FC<IRenderColumnTemplate> = ({
  rowOriginal,
  e2eData,
}) => {
  const { displayValue, tooltipContent } = useCourseStationsCell(rowOriginal);

  if (!displayValue) {
    return null;
  }

  return (
    <div
      className="cell_simple"
      data-e2e-type="course-stations-cell"
      data-e2e-custom={e2eData}
    >
      <FramerTooltip
        content={tooltipContent}
        placement={PopoverPlacement.bottom}
      >
        <span>{displayValue}</span>
      </FramerTooltip>
    </div>
  );
};
